/*
 * Reliance — Moteur des diagnostics (sections/rel-diagnostic.liquid ; specs _docs/specs/diagnostic-*.md).
 *  - questions : choix unique, Précédent / Suivant, pastilles ; retour arrière sans effacer les réponses ;
 *  - progression (étape, réponses, résultat affiché, alternative) en sessionStorage (« Clé de mémorisation ») ;
 *  - « Recommencer » : vide les réponses et l'entrée sessionStorage, revient à la question 1.
 * Logique de résultat selon data-logic :
 *  - corps (E.1b) : fragrance = réponse à « q3 » (clé du bloc « Résultat ») ; texture = lait si « q2 » vaut
 *    « q2-nourri », sinon huile ; « q1 » n'ajoute qu'une phrase de contexte (sauf « q1-aucun »).
 *    Rituel : produits 1 (gel), 2 (gommage) et 3 (huile) ou 4 (lait) du bloc.
 *  - visage (E.2b) : famille (q4, repli q1), degré N10→N30 (score q1 + q2 + q3, plafonné à N20 si « brillance »),
 *    active (priorités sur q1 / q2), sérum (q1), nettoyage simple ou alterné (q1 / q2) ; l'autre famille est
 *    proposée en alternative (« Voir celle-là plutôt » inverse les deux). Clés = blocs « Produit recommandé ».
 * Panier : « Ajouter au panier » → RelSelectionCart.addToCart (assets/rel-selection-cart.js), produits disponibles
 * seulement. Les boutons du résultat reportent aussi la recommandation sur la page : Composer corps
 * (el.relComposer) ou composeur + « Votre routine » visage (el.relCremes, el.relRoutine), s'ils existent.
 * Contrat data-* : en tête de la section.
 */
(function () {
  if (window.relDiagnosticInit) return;
  window.relDiagnosticInit = true;

  var STORAGE_VERSION = 1;

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function readStorage(key) {
    if (!key) return null;
    try {
      var data = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      return data && data.v === STORAGE_VERSION ? data : null;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(key, data) {
    if (!key) return;
    try {
      if (data) window.sessionStorage.setItem(key, JSON.stringify(data));
      else window.sessionStorage.removeItem(key);
    } catch (e) {
      /* stockage indisponible : la progression reste en mémoire */
    }
  }

  function money(cents, root) {
    if (window.RelSelectionCart) return window.RelSelectionCart.formatMoney(cents, root.getAttribute('data-money-format'));
    return (cents / 100).toFixed(2);
  }

  function lowerFirst(text) {
    return text ? text.charAt(0).toLowerCase() + text.slice(1) : '';
  }

  /* ---------- logique corps ---------- */
  function corps(answers, root) {
    var fragrance = answers.q3;
    var panel = fragrance && root.querySelector('[data-rel-diagnostic-reco="' + fragrance + '"]');
    if (!panel) return null;
    var texture = answers.q2 === 'q2-nourri' ? 'lait' : 'huile';
    var slots = ['1', '2', texture === 'lait' ? '4' : '3'];
    var why = [panel.getAttribute('data-text') || '', root.getAttribute('data-why-' + texture) || ''];
    if (answers.q1 && answers.q1 !== 'q1-aucun') {
      var choice = root.querySelector('[data-rel-quiz-choice="' + answers.q1 + '"]');
      var template = root.getAttribute('data-need-template') || '';
      if (choice && template) why.push(template.replace('[need]', lowerFirst(choice.textContent.trim())));
    }
    var base = root.querySelector('[data-rel-diagnostic-detail]');
    return {
      panel: panel,
      cards: slots
        .map(function (slot) {
          return panel.querySelector('[data-rel-diagnostic-slot="' + slot + '"]');
        })
        .filter(Boolean),
      render: function () {
        var box = panel.querySelector('[data-rel-diagnostic-why]');
        if (box) box.textContent = why.filter(Boolean).join(' ');
      },
      detail: [base ? base.getAttribute('data-base') : '', root.getAttribute('data-texture-' + texture)].filter(Boolean).join(' · '),
      apply: function () {
        var composer = document.querySelector('[data-rel-composer]');
        if (!composer || !composer.relComposer) return;
        composer.relComposer.setFragrance(fragrance);
        var selection = composer.relSelection;
        if (!selection) return;
        selection.select(texture === 'lait' ? 'huile' : 'lait', false);
        ['gel', 'gommage', texture].forEach(function (role) {
          selection.select(role, true);
        });
      },
    };
  }

  /* ---------- logique visage ---------- */
  var DEGREES = ['n10', 'n20', 'n25', 'n30'];

  function visageFamily(a) {
    if (a.q4 === 'q4-confort-ajuste') return 'sur-mesure';
    if (a.q4 === 'q4-reponse-concentree') return 'active';
    return ['q1-rides-fermete', 'q1-taches', 'q1-premieres-rides', 'q1-rougeurs'].indexOf(a.q1) !== -1 ? 'active' : 'sur-mesure';
  }

  function visageDegree(a) {
    var score = 1;
    if (a.q1 === 'q1-secheresse') score += 1;
    if (a.q1 === 'q1-brillance') score -= 1;
    if (a.q2 === 'q2-tiraille') score += 1;
    if (a.q2 === 'q2-inconfortable') score += 2;
    if (a.q2 === 'q2-zone-t') score -= 1;
    if (a.q3 === 'q3-plus-seche') score += 1;
    score = Math.max(0, Math.min(3, score));
    if (a.q1 === 'q1-brillance') score = Math.min(score, 1); /* plafond N20, décision 2026-09-23 */
    return DEGREES[score];
  }

  function visageActive(a) {
    if (a.q1 === 'q1-rides-fermete') return 'anti-age';
    if (a.q1 === 'q1-taches') return 'eclat';
    if (a.q1 === 'q1-rougeurs' || a.q2 === 'q2-inconfortable') return 'cocooning';
    if (a.q1 === 'q1-premieres-rides') return 'hyaluronique';
    if (a.q1 === 'q1-secheresse') return 'cocooning';
    return 'hyaluronique';
  }

  function visage(answers, root, state) {
    var panel = root.querySelector('[data-rel-diagnostic-composed]');
    if (!panel) return null;
    function item(key) {
      return panel.querySelector('[data-rel-diagnostic-item="' + key + '"]');
    }
    var family = visageFamily(answers);
    if (state.alt) family = family === 'active' ? 'sur-mesure' : 'active';
    var altFamily = family === 'active' ? 'sur-mesure' : 'active';
    var creamKey = { 'sur-mesure': visageDegree(answers), active: visageActive(answers) };
    var cream = item(creamKey[family]);
    var altCream = item(creamKey[altFamily]);
    var serum = item(['q1-rides-fermete', 'q1-premieres-rides'].indexOf(answers.q1) !== -1 ? 'deplisseur' : 'eveilleur');
    var alternate = answers.q1 === 'q1-brillance' || answers.q2 === 'q2-zone-t';
    var cleansers = (alternate ? ['micellaire', 'argile'] : ['argile']).map(item);
    var cards = cleansers.concat([serum, cream]).filter(Boolean);
    if (!cream) return null;

    function name(el) {
      return el ? el.getAttribute('data-title') || '' : '';
    }

    var cleanVolume = cleansers[0] ? cleansers[0].getAttribute('data-volume') || '' : '';
    var detail = (root.getAttribute('data-detail-visage') || '')
      .replace('[count]', root.getAttribute(cards.length === 4 ? 'data-count-4' : 'data-count-3') || String(cards.length))
      .replace('[volume]', cleanVolume);

    return {
      panel: panel,
      cards: cards,
      detail: detail,
      render: function () {
        var familyBox = panel.querySelector('[data-rel-diagnostic-family]');
        if (familyBox) familyBox.textContent = familyBox.getAttribute(family === 'active' ? 'data-label-active' : 'data-label-sur-mesure') || '';
        var title = panel.querySelector('[data-rel-diagnostic-title]');
        if (title) title.textContent = name(cream);
        var why = panel.querySelector('[data-rel-diagnostic-why]');
        if (why) why.textContent = cream.getAttribute('data-text') || '';
        var alt = panel.querySelector('[data-rel-diagnostic-alt]');
        if (!alt) return;
        alt.hidden = !altCream;
        if (!altCream) return;
        var suffix = altFamily === 'active' ? 'active' : 'sur-mesure';
        var altLabel = alt.querySelector('[data-rel-diagnostic-alt-label]');
        var altTitle = alt.querySelector('[data-rel-diagnostic-alt-title]');
        var altText = alt.querySelector('[data-rel-diagnostic-alt-text]');
        var apply = alt.querySelector('[data-rel-diagnostic-alt-apply]');
        if (altLabel) altLabel.textContent = alt.getAttribute('data-label-' + suffix) || '';
        if (altTitle) altTitle.textContent = name(altCream);
        if (altText) altText.textContent = alt.getAttribute('data-text-' + suffix) || '';
        if (apply) apply.disabled = false;
      },
      apply: function () {
        var cremes = document.querySelector('[data-rel-cremes]');
        if (cremes && cremes.relCremes) cremes.relCremes.chooseProduct(cream.getAttribute('data-product-handle'));
        var routine = document.querySelector('[data-rel-routine]');
        if (!routine || !routine.relRoutine) return;
        var keys = [];
        var volumes = {};
        if (serum) keys.push('serum-' + serum.getAttribute('data-product-handle'));
        cleansers.filter(Boolean).forEach(function (el) {
          var key = 'nettoyant-' + el.getAttribute('data-product-handle');
          keys.push(key);
          volumes[key] = el.getAttribute('data-variant-id');
        });
        routine.relRoutine.applyReco(keys, volumes);
      },
    };
  }

  var LOGICS = { corps: corps, visage: visage };

  function init(root) {
    if (root.relDiagnostic) return;
    var logic = LOGICS[root.getAttribute('data-logic')];
    var storageKey = root.getAttribute('data-storage-key');
    var steps = all(root, '[data-rel-quiz-step]');
    var resultBox = root.querySelector('[data-rel-diagnostic-result]');
    var addButton = root.querySelector('[data-rel-diagnostic-add]');
    var message = root.querySelector('[data-rel-diagnostic-message]');
    var state = { step: 0, answers: {}, done: false, alt: false };
    var current = null;
    var busy = false;

    function questionId(step) {
      return step.getAttribute('data-rel-diagnostic-question');
    }

    function save() {
      writeStorage(storageKey, { v: STORAGE_VERSION, step: state.step, answers: state.answers, done: state.done, alt: state.alt });
    }

    /* ---------- questions ---------- */
    function renderSteps(focus) {
      steps.forEach(function (step, i) {
        step.hidden = state.done || i !== state.step;
        var answer = state.answers[questionId(step)];
        all(step, '[data-rel-quiz-choice]').forEach(function (choice) {
          choice.setAttribute('aria-pressed', choice.getAttribute('data-rel-quiz-choice') === answer ? 'true' : 'false');
        });
        var next = step.querySelector('[data-rel-quiz-next], [data-rel-diagnostic-submit]');
        if (next) next.disabled = !answer || (next.hasAttribute('data-rel-diagnostic-submit') && !logic);
      });
      if (focus && !state.done) {
        var legend = steps[state.step] && steps[state.step].querySelector('legend');
        if (legend) {
          legend.setAttribute('tabindex', '-1');
          legend.focus({ preventScroll: true });
        }
      }
    }

    /* ---------- résultat ---------- */
    function setAddState(status, text) {
      if (!addButton) return;
      addButton.setAttribute('aria-busy', status === 'busy' ? 'true' : 'false');
      addButton.disabled = status === 'busy' || status === 'empty';
      addButton.textContent =
        status === 'busy'
          ? root.getAttribute('data-label-adding')
          : status === 'added'
          ? root.getAttribute('data-label-added')
          : root.getAttribute('data-label-add');
      if (message) {
        message.textContent = text || '';
        message.setAttribute('role', status === 'error' ? 'alert' : 'status');
      }
    }

    function renderResult(focus) {
      current = state.done && logic ? logic(state.answers, root, state) : null;
      if (state.done && !current) state.done = false;
      if (resultBox) resultBox.hidden = !current;
      all(root, '[data-rel-diagnostic-reco], [data-rel-diagnostic-composed]').forEach(function (panel) {
        panel.hidden = !current || panel !== current.panel;
      });
      if (!current) return;
      var total = 0;
      var available = 0;
      all(current.panel, '[data-rel-diagnostic-slot], [data-rel-diagnostic-item]').forEach(function (card) {
        var index = current.cards.indexOf(card);
        card.hidden = index === -1;
        card.style.order = index === -1 ? '' : String(index);
        if (index !== -1 && card.getAttribute('data-available') === 'true') {
          total += Number(card.getAttribute('data-price')) || 0;
          available += 1;
        }
      });
      if (current.render) current.render();
      var detail = root.querySelector('[data-rel-diagnostic-detail]');
      if (detail) detail.textContent = current.detail || detail.getAttribute('data-base') || '';
      var totalBox = root.querySelector('[data-rel-diagnostic-total]');
      if (totalBox) totalBox.textContent = total ? money(total, root) : '';
      setAddState(available ? 'idle' : 'empty');
      if (focus) {
        var label = resultBox.querySelector('[data-rel-diagnostic-focus]');
        if (label) {
          label.setAttribute('tabindex', '-1');
          label.focus({ preventScroll: true });
        }
      }
    }

    function render(focus) {
      renderSteps(focus);
      renderResult(focus);
      if (state.done && !current) renderSteps(false);
    }

    function shownCards() {
      return current ? current.cards.filter(function (card) {
        return !card.hidden;
      }) : [];
    }

    function applyToPage() {
      if (current && current.apply) current.apply();
    }

    function addToCart() {
      if (busy || !window.RelSelectionCart || !current) return;
      var cards = shownCards();
      var list = cards
        .filter(function (card) {
          return card.getAttribute('data-available') === 'true' && card.getAttribute('data-variant-id');
        })
        .map(function (card) {
          return { id: Number(card.getAttribute('data-variant-id')), quantity: 1 };
        });
      if (!list.length) return;
      var absent = cards
        .filter(function (card) {
          return card.getAttribute('data-available') !== 'true';
        })
        .map(function (card) {
          return card.getAttribute('data-title') || '';
        });
      busy = true;
      setAddState('busy');
      applyToPage();
      window.RelSelectionCart.addToCart(list, { trigger: addButton })
        .then(function () {
          busy = false;
          var note = absent.length ? (root.getAttribute('data-label-partial') || '').replace('[products]', absent.join(', ')) : '';
          setAddState('added', note);
        })
        .catch(function (error) {
          busy = false;
          setAddState('error', (error && error.description) || root.getAttribute('data-label-error') || '');
        });
    }

    /* ---------- événements ---------- */
    steps.forEach(function (step, i) {
      all(step, '[data-rel-quiz-choice]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          state.answers[questionId(step)] = choice.getAttribute('data-rel-quiz-choice');
          save();
          renderSteps(false);
        });
      });
      var next = step.querySelector('[data-rel-quiz-next]');
      if (next) {
        next.addEventListener('click', function () {
          if (!state.answers[questionId(step)] || i + 1 >= steps.length) return;
          state.step = i + 1;
          save();
          render(true);
        });
      }
      var prev = step.querySelector('[data-rel-quiz-prev]');
      if (prev) {
        prev.addEventListener('click', function () {
          if (i === 0) return;
          state.step = i - 1;
          save();
          render(true);
        });
      }
      var submit = step.querySelector('[data-rel-diagnostic-submit]');
      if (submit) {
        submit.addEventListener('click', function () {
          if (!logic || !state.answers[questionId(step)]) return;
          state.done = true;
          state.alt = false;
          save();
          render(true);
        });
      }
    });

    var restart = root.querySelector('[data-rel-diagnostic-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { step: 0, answers: {}, done: false, alt: false };
        writeStorage(storageKey, null);
        render(true);
      });
    }

    var altApply = root.querySelector('[data-rel-diagnostic-alt-apply]');
    if (altApply) {
      altApply.addEventListener('click', function () {
        state.alt = !state.alt;
        save();
        render(false);
        if (message) message.textContent = '';
        var title = root.querySelector('[data-rel-diagnostic-title]');
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: false });
        }
      });
    }

    if (addButton) addButton.addEventListener('click', addToCart);

    all(root, '[data-rel-diagnostic-apply]').forEach(function (link) {
      link.addEventListener('click', applyToPage);
    });

    /* ---------- démarrage ---------- */
    var saved = readStorage(storageKey);
    if (saved) {
      var step = Number(saved.step);
      if (step >= 0 && step < steps.length) state.step = step;
      if (saved.answers && typeof saved.answers === 'object') {
        steps.forEach(function (s) {
          var id = questionId(s);
          var value = saved.answers[id];
          if (value && s.querySelector('[data-rel-quiz-choice="' + value + '"]')) state.answers[id] = value;
        });
      }
      state.done = !!saved.done;
      state.alt = !!saved.alt;
    }
    render(false);

    root.relDiagnostic = {
      getState: function () {
        return { step: state.step, answers: Object.assign({}, state.answers), done: state.done, alt: state.alt };
      },
      applyToPage: applyToPage,
    };
  }

  function boot() {
    document.querySelectorAll('[data-rel-diagnostic]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
